var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"communityid-tooltip\">\r\n    <div class=\"tooltip-container\">\r\n        <div class=\"tooltip-container-inner tooltip-container-bg\">\r\n        </div>\r\n        <div class=\"tooltip-container-inner tooltip-container-content\">\r\n            "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\r\n        </div>\r\n    </div>\r\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Scripts/templates/tooltips/tooltip.handlebars
// module id = 354
// module chunks = 1